import axios from 'axios';
;
;
;
;
;
;
;
function get(url, config) {
    return axios.get('/api' + url, config);
}
;
function post(url, data, config) {
    return axios.post('/api' + url, data, config);
}
export default { get: get, post: post };
